import { motion } from "framer-motion";

const links = [
  { label: "Verticals", href: "#verticals", id: "nav-link-verticals" },
  { label: "Customise", href: "#customise", id: "nav-link-customise" },
  { label: "Size Guide", href: "#size-guide", id: "nav-link-size-guide" },
  { label: "Manifesto", href: "#manifesto", id: "nav-link-manifesto" },
  { label: "About", href: "#about", id: "nav-link-about" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#26221F]/10 bg-[#FAF7F2]/90 backdrop-blur-sm"
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <a href="#top" className="flex items-center gap-4" data-testid="nav-logo">
          <img
            src="/logo-mark.jpeg"
            alt="Her Label logo"
            className="h-11 w-11 rounded-full border border-[#26221F]/10 object-cover"
          />
          <span className="font-display text-xl tracking-[0.3em]">HER LABEL</span>
        </a>
        <nav className="hidden items-center gap-10 md:flex" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-xs font-semibold uppercase tracking-[0.25em] text-[#6F665F] transition-colors duration-300 hover:text-[#26221F]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#waitlist"
            data-testid="nav-cta-waitlist"
            className="rounded-full bg-[#26221F] px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.25em] text-[#FAF7F2] transition-colors duration-300 hover:bg-[#D8AFA4] hover:text-[#26221F]"
          >
            Join Waitlist
          </a>
        </nav>
        <a
          href="#waitlist"
          data-testid="nav-cta-waitlist-mobile"
          className="rounded-full bg-[#26221F] px-5 py-2 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#FAF7F2] md:hidden"
        >
          Join Waitlist
        </a>
      </div>
    </motion.header>
  );
}
